var map = {
	"./CollectDetailDefaultLayout": [
		"bb0c",
		"chunk-3ee690dc"
	],
	"./CollectDetailDefaultLayout.vue": [
		"bb0c",
		"chunk-3ee690dc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6d92";
module.exports = webpackAsyncContext;